module.exports = __webpack_public_path__ + "img/ozon.bf149037.png";